import Vue from 'vue'
import methods from './methods'

Vue.mixin({
	methods
})
